import { render } from "./StickyAppBanner.vue?vue&type=template&id=1a0382d2&scoped=true"
import script from "./StickyAppBanner.vue?vue&type=script&lang=js"
export * from "./StickyAppBanner.vue?vue&type=script&lang=js"

import "./StickyAppBanner.vue?vue&type=style&index=0&id=1a0382d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0382d2"]])

export default __exports__